import type { CSSProperties, ReactElement, ReactNode, RefObject } from 'react';
import { AnimatePresence, motion, type Variants } from 'framer-motion';
import type { ContainerPreset } from '@/constants/componentPresets';
import { Cblurbackdrop } from '../Cblurbackdrop/Cblurbackdrop';
import { Ccontainer } from '../Ccontainer';
import { Cportal } from '../Cportal';
import { POPOVER_BACKDROP_ANIMATION_MS, POPOVER_HEIGHT_WRAPPER_TRANSITION, POPOVER_MOTION_STATE, } from './constants';
import { getPopoverContentWrapperStyle, getPopoverPortalContainerId, getPopoverSurfaceStyle, } from './popover-selectors';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CpopoverLayerProps {
    dataElScope: DataElScope;
    backdropBlur: number;
    backdropOpacity: number;
    boxShadow?: string;
    children?: ReactNode;
    contentWrapperStyle?: CSSProperties;
    motionStyle: CSSProperties | null;
    onClose?: () => void;
    padding: number | string;
    popoverRef: RefObject<HTMLDivElement | null>;
    popoverZIndex: number;
    preset: ContainerPreset;
    radius: number;
    showPopover: boolean;
    surfaceStyle?: CSSProperties;
    variants: Variants;
    withBackdrop: boolean;
    zIndexOverride?: number;
}
export function CpopoverLayer({ dataElScope, backdropBlur, backdropOpacity, boxShadow, children, contentWrapperStyle, motionStyle, onClose, padding, popoverRef, popoverZIndex, preset, radius, showPopover, surfaceStyle, variants, withBackdrop, zIndexOverride, }: CpopoverLayerProps): ReactElement {
    return (
      <Cportal containerId={getPopoverPortalContainerId({ zIndexOverride })} containerZIndex={zIndexOverride}>
        {withBackdrop && (<Cblurbackdrop visible={showPopover} opacity={backdropOpacity} blur={backdropBlur} useGradient={false} animationDuration={POPOVER_BACKDROP_ANIMATION_MS} zIndexOverride={popoverZIndex} onClick={onClose}/>)}
        <AnimatePresence>
          {showPopover && (<motion.div data-el={dataEl(dataElScope, 'Layer/Root')} key="cpopover-root" ref={popoverRef} style={motionStyle ?? undefined} variants={variants} initial={POPOVER_MOTION_STATE.Hidden} animate={POPOVER_MOTION_STATE.Visible} exit={POPOVER_MOTION_STATE.Exit}>
              <motion.div data-el={dataEl(dataElScope, 'Layer/HeightFrame')} layout transition={POPOVER_HEIGHT_WRAPPER_TRANSITION} style={{ width: '100%' }}>
                <Ccontainer preset={preset} radius={radius} padding={padding} flexDirection="column" gap={0} boxShadow={boxShadow} style={getPopoverSurfaceStyle({ surfaceStyle })} contentWrapperStyle={getPopoverContentWrapperStyle({
                contentWrapperStyle,
            })}>
                  {children}
                </Ccontainer>
              </motion.div>
            </motion.div>)}
        </AnimatePresence>
      </Cportal>
    );
}
